angular.module('app.prospection.common', []);
/**
 * Module commun prospection
 * @module app.prospection.common
 */
require('modules/prospection/common/directives/messages');

angular
    .module('app.prospection.common')
    // .config(prospectionCommonDB)
    .directive('bmFocus', function() {
        return {
            restrict: 'A',
            link: function($scope, elem, attrs) {
                elem.bind('keydown', function(e) {
                    var code = e.keyCode || e.which;
                    if (code === 13) {
                        e.preventDefault();
                        elem[0].blur();
                    }
                });
            }
        };
    })
    .directive('dateFormat', function() {
        return {
            require: 'ngModel',
            link: function(scope, element, attr, ngModelCtrl) {
                // Angular 1.3 insert a formater that force to set model to date object, otherwise throw exception.
                // Reset default angular formatters/parsers
                ngModelCtrl.$formatters.length = 0;
                ngModelCtrl.$parsers.length = 0;
            }
        };
    })
    .filter('month', function dateUsToFormat() {
        var MONTHS = [
            'Janvier',
            'Février',
            'Mars',
            'Avril',
            'Mai',
            'Juin',
            'Juillet',
            'Août',
            'Septembre',
            'Octobre',
            'Novembre',
            'Décembre'
        ];

        return function(input, format) {
            return MONTHS[input % 12];
        };
    });
